import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=206f84ea&scoped=true"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=206f84ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f84ea",
  null
  
)

export default component.exports